<template>
  <div class="container-fluid">
    <div class="function-card">
      <button
        type="button"
        class="btn btn-primary"
        style="margin-top: 30px; margin-right: 10px"
        data-toggle="modal"
        data-target="#factoryModal"
        @click="factoryModal({ action: 'add' })"
      >
        {{ i18n("Buttons.Add") }}
      </button>
    </div>
    <div class="yahome-table-wrap">
      <VueBootstrap4Table
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="totalData"
        @on-change-query="changePage"
      >
        <template slot="IsSupervisor" slot-scope="props">
          <span v-if="props.cell_value">是</span>
          <span v-else>否</span>
        </template>

        <template slot="IsEnabled" slot-scope="props">
          <eva-icon
            v-if="props.cell_value"
            fill="#000"
            name="checkmark-outline"
          />
          <eva-icon v-else fill="#000" name="close-outline" />
        </template>

        <template slot="Edit" slot-scope="props">
          <button
            type="button"
            class="btn btn-info btn-sm"
            data-toggle="modal"
            data-target="#factoryModal"
            @click="factoryModal({ action: 'edit', data: props.row })"
          >
            {{ i18n("Buttons.Edit") }}
          </button>
        </template>
        <template slot="Delete" slot-scope="props">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-toggle="modal"
            data-target="#delFactoryModal"
            @click="factory = { ...props.row }"
          >
            {{ i18n("Buttons.Delete") }}
          </button>
        </template>
        <template slot="empty-results"> 暫無資料 </template>
      </VueBootstrap4Table>
    </div>

    <!-- 新增、編輯 Modal -->
    <div
      id="factoryModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="factory"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span v-if="action === 'add'">新增廠別</span>
              <span v-else>編輯廠別</span>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <ValidationProvider
                  name="廠別"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="modal-factory-name">
                    <span class="mark">*</span>
                    廠別
                  </label>
                  <input
                    type="text"
                    id="modal-factory-name"
                    class="form-control"
                    maxlength="200"
                    @compositionstart="is_composing = true"
                    @compositionend="is_composing = false"
                    v-model.trim="factory.Name"
                  />
                  <span v-if="errors[0] && !is_composing" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider
                  name="代碼"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="modal-factory-code">
                    <span class="mark">*</span>
                    代碼
                  </label>
                  <input
                    type="text"
                    id="modal-factory-code"
                    class="form-control"
                    maxlength="200"
                    v-model.trim="factory.Code"
                  />
                  <span v-if="errors[0] && !is_composing" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(saveFactory)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 刪除 Modal -->
    <div
      id="delFactoryModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">刪除廠別</div>
          <div class="modal-body">
            確認刪除
            <span style="font-weight: bolder; color: red">
              {{ factory.Name }}
            </span>
            ?
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="delFactory"
            >
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import { config } from "@/components/back/table_config.js";

export default {
  name: "WorkPlaceMaintenance",

  data() {
    return {
      // compositionstart& compositionend
      is_composing: false,

      // 判斷新增、編輯
      action: "add",

      factory: {},

      search: {},

      rows: [],
      totalData: 0,

      // 分頁資訊
      tableInfo: {
        page: 1,
        per_page: 10,
      },

      columns: [
        {
          label: "廠別",
          name: "Name",
        },
        {
          label: "代碼",
          name: "Code",
        },
        {
          label: "",
          name: "Edit",
          slot_name: "Edit",
        },
        {
          label: "",
          name: "Delete",
          slot_name: "Delete",
        },
      ],

      config: {
        ...config,
        server_mode: true,
      },
    };
  },

  methods: {
    // 換頁
    changePage(queryParams) {
      this.tableInfo = queryParams;
      this.getFactory();
    },

    // 取得 廠別
    getFactory() {
      this.updateLoading(true);
      this.$api.factory
        .getFactoryPaging({
          Keyword: null,
          page: this.tableInfo.page,
          perPage: this.tableInfo.per_page,
        })
        .then((response) => {
          if (response.status === 200) {
            this.rows = response.data.Data;
            this.totalData = response.data.SearchQuantity;
          }
          this.updateLoading(false);
        });
    },

    // 廠別 Modal
    factoryModal({ action, data }) {
      switch (action) {
        case "add":
          this.factory = {};
          this.action = "add";
          break;
        case "edit":
          this.factory = { ...data };
          this.action = "edit";
          break;
      }
      this.$refs.factory.reset();
    },

    // 新增、編輯 廠別
    saveFactory() {
      $("#factoryModal").modal("hide");
      let message;
      this.updateLoading(true);
      switch (this.action) {
        case "add":
          message = "新增成功";
          this.$api.factory
            .postFactory({
              ...this.factory,
              CreateUser: this.$cookies.get("userId"),
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getFactory();
              }
              this.updateLoading(false);
            });
          break;
        case "edit":
          message = "編輯成功";
          this.$api.factory
            .putFactory({
              ...this.factory,
              UpdateUser: this.$cookies.get("userId"),
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getFactory();
              }
              this.updateLoading(false);
            });
          break;
      }
    },

    // 刪除 廠別
    delFactory() {
      this.updateLoading(true);
      this.$api.factory
        .deleteFactory({ Guid: this.factory.Guid })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "刪除成功",
              type: "success",
              duration: 2000,
            });
            this.getFactory();
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
